import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import axios from 'axios'
import util from './libs/util'
import '@/assets/style/index.scss'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)
if (typeof window !== 'undefined') {
  window.axios = axios
}

Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.$axios = axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
